var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8143 6.64453C12.1698 6.64453 12.4706 6.37109 12.4706 5.98828C12.4706 5.63281 12.1698 5.33203 11.8143 5.33203C11.4589 5.33203 11.1581 5.63281 11.1581 5.98828C11.1581 6.37109 11.4589 6.64453 11.8143 6.64453ZM4.56824 6.64453C4.92371 6.64453 5.22449 6.37109 5.22449 5.98828C5.22449 5.63281 4.92371 5.33203 4.56824 5.33203C4.21277 5.33203 3.91199 5.63281 3.91199 5.98828C3.91199 6.37109 4.21277 6.64453 4.56824 6.64453ZM12.0604 2.70703C14.3026 3.9375 15.8339 6.20703 16.08 8.88672H0.329956C0.548706 6.20703 2.07996 3.9375 4.32214 2.70703L3.00964 0.4375C2.9823 0.382812 2.9823 0.328125 2.9823 0.273438C2.9823 0.136719 3.09167 0 3.25574 0C3.36511 0 3.44714 0.0820312 3.50183 0.164062L4.81433 2.46094C5.85339 1.99609 7.00183 1.75 8.20496 1.75C9.40808 1.75 10.5292 1.99609 11.5682 2.46094L12.8807 0.164062C12.9354 0.0820312 13.0175 0 13.1268 0C13.2909 0 13.4003 0.136719 13.4003 0.273438C13.4003 0.328125 13.4003 0.382812 13.3729 0.4375L12.0604 2.70703Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.44baed67.svg";
export { ForwardRef as ReactComponent };